module.exports = __webpack_public_path__ + "img/album18_19.69aaa3a0.jpg";